export default "__VITE_ASSET__BEfR8SXb__"